import React from 'react';
import styled from 'styled-components';
import Base from '@material-ui/core/LinearProgress';

const LinearProgress = () => {
    const StyledThing = styled(Base)`
      margin: ${props => props.theme.space[10]} 0;
    `;

    return (
        <StyledThing />
    );
};

export default LinearProgress;



// WEBPACK FOOTER //
// ./src/components/LinearProgress.js